export default __webpack_public_path__ + "static/media/sx.2175354a.svg";